// 商城管理相关页面组件
// 使用相对路径导入组件
import EmptyRouterView from '../components/EmptyRouterView/index.vue'
import StoreHome from '../views/store/StoreHome.vue'
import OwnerManagement from '../views/store/OwnerManagement.vue'
import ShopManagement from '../views/store/ShopManagement.vue'
import CategoryManagement from '../views/store/CategoryManagement.vue'
import GoodsManagement from '../views/store/GoodsManagement.vue'

import OrderManagement from '../views/store/OrderManagement.vue'
import OrderGoodsManagement from '../views/store/OrderGoodsManagement.vue'

// 商城管理路由配置
export const storeRoutes = {
  path: 'store',
  name: 'Store',
  component: EmptyRouterView,
  meta: {
    title: '商城管理',
    icon: 'el-icon-shopping-cart-full',
    hidden: false
  },
  children: [
    {
      path: 'store-home',
      name: 'StoreHome',
      component: StoreHome,
      meta: {
        title: '商城概览',
        icon: 'el-icon-data-board',
        hidden: false
      }
    },
    {
      path: 'owner',
      name: 'OwnerManagement',
      component: OwnerManagement,
      meta: {
        title: '店主管理',
        icon: 'el-icon-user',
        hidden: false
      }
    },
    {
      path: 'shop',
      name: 'ShopManagement',
      component: ShopManagement,
      meta: {
        title: '店铺管理',
        icon: 'el-icon-office-building',
        hidden: false
      }
    },
    {
      path: 'category',
      name: 'CategoryManagement',
      component: CategoryManagement,
      meta: {
        title: '分类管理',
        icon: 'el-icon-menu',
        hidden: false
      }
    },
    {
      path: 'goods',
      name: 'GoodsManagement',
      component: GoodsManagement,
      meta: {
        title: '商品管理',
        icon: 'el-icon-goods',
        hidden: false
      }
    },
    {
      path: 'order',
      name: 'OrderManagement',
      component: OrderManagement,
      meta: {
        title: '订单管理',
        icon: 'el-icon-document-checked',
        hidden: false
      }
    },
    {
      path: 'order-goods',
      name: 'OrderGoodsManagement',
      component: OrderGoodsManagement,
      meta: {
        title: '订单商品管理',
        icon: 'el-icon-s-order',
        hidden: false
      }
    }
  ]
}